import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Loadable from '../layouts/loader/Loadable';

const Private = ({ children }) => {
  const token = localStorage.getItem('sessionToken');

  if (!token) {
    return <Navigate to="/" />;
  }

  return children;
};

const PrivateLogin = ({ children }) => {
  const token = localStorage.getItem('sessionToken');

  if (token) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/BlankLayout')));
const LoginFormik = Loadable(lazy(() => import('../pages/LoginFormik')));
const Dashboard = Loadable(lazy(() => import('../pages/Dashboard')));
const Despesas = Loadable(lazy(() => import('../pages/Despesas')));
const Empreendimentos = Loadable(lazy(() => import('../pages/Empreendimentos')));
const Favorecidos = Loadable(lazy(() => import('../pages/Favorecidos')));
const Centrocusto = Loadable(lazy(() => import('../pages/Centrocusto')));
const Funcionarios = Loadable(lazy(() => import('../pages/Funcionarios')));
const Planejamento = Loadable(lazy(() => import('../pages/Planejamento')));
const Configuracoes = Loadable(lazy(() => import('../pages/Configuracoes')));
const Auditoria = Loadable(lazy(() => import('../pages/Auditoria')));

const ThemeRoutes = [
  {
    path: '/',
    element: <BlankLayout />,
    children: [
      {
        path: '/',
        name: 'login',
        element: (
          <PrivateLogin>
            <LoginFormik />
          </PrivateLogin>
        ),
      },
    ],
  },
  {
    path: '/',
    element: (
      <Private>
        <FullLayout />
      </Private>
    ),
    children: [
      { path: 'dashboard', name: 'Dashboard', exact: true, element: <Dashboard /> },
      { path: 'despesas', name: 'Despesas', exact: true, element: <Despesas /> },
      { path: 'empreendimentos', name: 'Empreendimentos', exact: true, element: <Empreendimentos /> },
      { path: 'favorecidos', name: 'Favorecidos', exact: true, element: <Favorecidos /> },
      { path: 'centrocusto', name: 'Centrocusto', exact: true, element: <Centrocusto /> },
      { path: 'funcionarios', name: 'Funcionarios', exact: true, element: <Funcionarios /> },
      { path: 'planejamento', name: 'Planejamento', exact: true, element: <Planejamento /> },
      { path: 'configuracoes', name: 'Configuracoes', exact: true, element: <Configuracoes /> },
      { path: 'auditoria', name: 'Auditoria', exact: true, element: <Auditoria /> },
    ],
  },
];

Private.propTypes = {
  children: PropTypes.node.isRequired,
};

PrivateLogin.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ThemeRoutes;
